import {
  Badge,
  Box,
  Button,
  Grid,
  Group,
  Input,
  MultiSelect,
  MultiSelectProps,
  Select,
  Text,
  Tooltip,
  rem,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import {
  IconBarcode,
  IconBrandBootstrap,
  IconBuildingFactory,
  IconBuildingWarehouse,
  IconFileExport,
  IconFileTypography,
  IconSearch,
  IconSwitch,
  IconTimeDuration15,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_MDM } from "../../../config";
import { _localization } from "../../../config/location";
import { ComboboxItem } from "../../../model/ComboboxItem";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import {
  getMasterOrgSelect,
  getTblInventoryTransactionType3,
} from "../../../service/getSelectApi";

const userLoginHeader = JSON.parse(
  localStorage.getItem("userLoginHeader") || "{}"
);

type SearchContext = {
  keySearch?: string;
  LoaiGdNhapXuat?: string;
  maViTriList: Array<string>;
  maKhoList: Array<string>;
  maCn: Array<string>;
  itemCode: Array<string>;
  StartTime?: Date | null | string;
  EndTime?: Date | null | string;
  LoaiChungTuList?: string;
  MaChiNhanhs?: Array<string>;
};
const InventoryTransactionsReport = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<Department[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const sizeGrid = { base: 12, sm: 6, md: 4, lg: 2, xl: 2 };

  const [dataTotalItem, setDataTotalItem] = useState<any>();

  const [dataTblInventoryTransactionType, setDataTblInventoryTransactionType] =
    useState<ComboboxItem[]>([]);
  const [dataBranch, setDataBranch] = useState<any[]>([]);
  const [dataInv, setDataInv] = useState<any[]>([]);
  const [dataPositionInv, setDataPositionInv] = useState<any[]>([]);

  const [selectIdBranch, setSelectIdBranch] = useState<string[]>([]);
  const [selectIdInv, setSelectIdInv] = useState<string[]>([]);

  const form = useForm<SearchContext>({
    mode: "uncontrolled",
    initialValues: {
      MaChiNhanhs: [] as string[],
      StartTime: new Date(
        new Date(
          new Date(new Date().setDate(new Date().getDate() - 14)).setHours(
            0,
            0,
            0,
            0
          )
        ).getTime() +
          7 * 60 * 60 * 1000
      ),
      EndTime: new Date(
        new Date(
          new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
            0,
            0,
            0,
            0
          )
        ).getTime() +
          7 * 60 * 60 * 1000
      ),
    } as SearchContext,
  });

  const navigate = useNavigate();

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
      },
      {
        accessorKey: "chungTuGoc",
        header: "Chứng từ gốc",
        size: 180,
        Cell: ({ renderedCellValue, cell, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            style={{ cursor: "pointer" }}
            size="md"
            onDoubleClick={() =>
              renderedCellValue === null ? null : handleCheckView(row)
            }
            color={renderedCellValue === null ? "red" : "#21d01b"}
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "maGd",
        header: "Mã giao dịch",
        size: 150,
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            {renderedCellValue === null ? null : (
              <Tooltip label="Xem chi tiết">
                <Badge
                  style={{ cursor: "pointer" }}
                  onDoubleClick={() =>
                    detailData(
                      row.original.transactionHeaderId,
                      row.original.sourceType,
                      true,
                      row.original.loaiGdNhapXuat,
                      row.original.chungTuGoc
                    )
                  }
                  bd="1px solid blue"
                  variant="light"
                  color="blue"
                >
                  {renderedCellValue}
                </Badge>
              </Tooltip>
            )}
          </>
        ),
      },
      {
        accessorKey: "ngayGd",
        header: "Ngày giao dịch",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        size: 150,
      },
      {
        accessorKey: "loaiGd",
        header: "Loại giao dịch",
        size: 250,
      },
      {
        accessorKey: "maCn",
        header: "Mã chi nhánh",
        size: 150,
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            {renderedCellValue === null ? null : (
              <Badge variant="light" color="violet">
                {renderedCellValue}
              </Badge>
            )}
          </>
        ),
      },
      {
        accessorKey: "tenCn",
        header: "Tên chi nhánh",
      },
      {
        accessorKey: "maKho",
        header: "Mã kho",
        size: 140,
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            {renderedCellValue === null ? null : (
              <Badge variant="light" color="blue">
                {renderedCellValue}
              </Badge>
            )}
          </>
        ),
      },
      {
        accessorKey: "maViTri",
        header: "Mã vị trí",
        size: 140,
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            {renderedCellValue === null ? null : (
              <Badge variant="light" color="blue">
                {renderedCellValue}
              </Badge>
            )}
          </>
        ),
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        size: 140,
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            {renderedCellValue === null ? null : (
              <Badge variant="light" color="blue">
                {renderedCellValue}
              </Badge>
            )}
          </>
        ),
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        size: 300,
      },
      {
        accessorKey: "serialNumber",
        header: "Serial",
        // Cell: ({ renderedCellValue, cell, row }) => (
        //   <Box
        //     style={{
        //       borderRadius: "30px",
        //       backgroundColor: "#E8F3FC",
        //       padding: "4px",
        //     }}
        //   >
        //     <Text variant="light" p="4px 8px" size="xs" color="blue" fw="bold">
        //       {renderedCellValue ?? ""}
        //     </Text>
        //   </Box>
        // ),
      },
      {
        accessorKey: "serialStatus",
        header: "Trạng thái serial",
        footer: "Tổng:",
        Footer(props) {
          return (
            <div>
              <Text c="red" size="13px" fw={800}>
                {props.column.columnDef.footer}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "soLuongNhap",
        header: "Số lượng nhập",
        // Cell: ({ renderedCellValue, row }) => (
        //   <>{row.original.soLuongNhap === 1 ? "Đã Nhập" : "Chưa Nhập"}</>
        // ),
        Footer: ({ table }: any) => {
          // const total = table
          //   .getRowModel()
          //   .rows.reduce(
          //     (sum: number, row: any) => sum + (row.original.soLuongNhap || 0),
          //     0
          //   );
          const total = dataTotalItem?.tongSlNhap;
          return (
            <Text ta="right" size="13px" c="red" fw={800}>
              {total}
            </Text>
          );
        },
      },
      {
        accessorKey: "soLuongXuat",
        header: "Số lượng xuất",
        // Cell: ({ renderedCellValue, row }) => (
        //   <>{row.original.soLuongXuat === 1 ? "Đã Xuất" : "Chưa Xuất"}</>
        // ),
        Footer: ({ table }: any) => {
          // const total = table
          //   .getRowModel()
          //   .rows.reduce(
          //     (sum: number, row: any) => sum + (row.original.soLuongXuat || 0),
          //     0
          //   );
          const total = dataTotalItem?.tongSlXuat;

          return (
            <Text ta="right" size="13px" c="red" fw={800}>
              {total}
            </Text>
          );
        },
      },
      {
        accessorKey: "donGia",
        header: "Đơn giá",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatNumber(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          // const total = table
          //   .getRowModel()
          //   .rows.reduce(
          //     (sum: number, row: any) => sum + (row.original.donGia || 0),
          //     0
          //   );
          const total = dataTotalItem?.tongDonGia;
          return (
            <Text ta="right" size="13px" c="red" fw={800}>
              {formatNumber(total)}
            </Text>
          );
        },
      },
      {
        accessorKey: "phongBanGd",
        header: "Phòng ban giao dịch",
      },
      {
        accessorKey: "tenNv",
        header: "Tên nhân viên",
        Cell: ({ renderedCellValue, row }) => (
          <>{renderedCellValue + " - " + row.original.maNv}</>
        ),
        size: 200,
      },

      {
        accessorKey: "dienGiai",
        header: "Diễn giải",
        size: 300,
      },
      // {
      //   accessorKey: "tenCnGd",
      //   header: "Tên chi nhánh giao dịch",
      //   size: 200,
      // },
    ],
    [dataTotalItem]
  );

  const formatNumber = (number: number) => {
    return new Intl.NumberFormat("vi-VN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>{dataItemCode.find((x) => x.value === option.value)?.label}</Text>
    </Group>
  );

  const detailData = (
    id: string | number,
    type: string | number | null,
    isLocked: boolean,
    category: number,
    chungTuGoc: string
  ) => {
    // window.open("/warehouse-config/detail-warehouse-out-ward", "_blank");
    if (category === 2) {
      navigate("/warehouse-config/detail-warehouse-out-ward", {
        state: { id: id, type: type, isLocked: isLocked },
      });
    } else {
      navigate(`/warehouse-config/detail-warehouse-in-ward`, {
        state: {
          id: id,
          sourceType: type,
          isLocked: isLocked,
          sourceCode: chungTuGoc,
        },
      });
    }
  };

  const handleCheckView = async (row: any) => {
    if (row.original.chungTuGoc.startsWith("DH")) {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.chungTuGoc}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        // Kiểm tra nếu orderNumber chứa "DT"
        if (row.original.chungTuGoc.includes("DT")) {
          navigate("/sell/view-order-return", {
            state: {
              id: row.original.id,
              orderNumber: row.original.chungTuGoc,
              orderType: 3,
              actionType: "view",
              // isReadOnly:
              //   location?.pathname === "/sell/sales-order-list-read-only"
              //     ? true
              //     : false,
            },
          });
        } else {
          navigate("/sell/view-order", {
            state: {
              id: row.original.id,
              orderNumber: row.original.chungTuGoc,
              orderType: 2,
              actionType: "view",
              // isReadOnly:
              //   location?.pathname === "/sell/sales-order-list-read-only"
              //     ? true
              //     : false,
            },
          });
        }
      }
    } else if (row.original.chungTuGoc.startsWith("XK")) {
      function mapSourceType(sourceType: string): string {
        return sourceType.startsWith("NHAP_")
          ? sourceType.replace("NHAP_", "XUAT_")
          : sourceType;
      }

      if (row.original.chungTuGoc.startsWith("XK")) {
        const modifiedSourceType = mapSourceType(row.original.sourceType);
        navigate("/warehouse-config/detail-warehouse-out-ward", {
          state: {
            id: row.original.transactionHeaderId,
            type: modifiedSourceType,
            isLocked: true,
          },
        });
      }
    } else if (row.original.chungTuGoc.startsWith("NK")) {
      function mapSourceType(sourceType: string): string {
        return sourceType.startsWith("XUAT_")
          ? sourceType.replace("XUAT_", "NHAP_")
          : sourceType;
      }

      if (row.original.chungTuGoc.startsWith("NK")) {
        const modifiedSourceType = mapSourceType(row.original.sourceType);
        navigate("/warehouse-config/detail-warehouse-in-ward", {
          state: {
            id: row.original.transactionHeaderId,
            type: modifiedSourceType,
            isLocked: true,
          },
        });
      }
    } else if (
      (row.original.chungTuGoc.startsWith("XN") ||
        row.original.chungTuGoc.startsWith("DC")) &&
      row.original.chungTuGoc.includes(".")
    ) {
      navigate("/warehouse-config/detail-request-transfer", {
        state: { sourceCode: row.original.chungTuGoc },
      });
    } else if (row.original.chungTuGoc.startsWith("PNHL")) {
      navigate("/warranty/receive-ticket-list", {
        state: { sourceCode: row.original.chungTuGoc, action: "DETAIL" },
      });
    } else if (row.original.loaiGd.startsWith("Nhập")) {
      navigate("/warehouse-config/detail-warehouse-in-ward", {
        state: {
          id: row?.original?.transactionHeaderId,
          sourceType: row?.original?.sourceType,
          isLocked: true,
          sourceCode: row?.original?.chungTuGoc,
        },
      });
    } else if (row.original.loaiGd.startsWith("Xuất")) {
      navigate("/warehouse-config/detail-warehouse-out-ward", {
        state: {
          id: row.original.transactionHeaderId,
          type: row.original.sourceType,
          isLocked: true,
          // sourceCode: row.original.chungTuGoc,
        },
      });
    } else if (row.original.chungTuGoc === null) {
      NotificationExtension.Fails("Số chứng từ không hợp lệ");
    }
  };

  const fetchData = async () => {
    const fromDate = new Date(form.getValues()?.StartTime ?? "");
    const toDate = new Date(form.getValues()?.EndTime ?? "");

    let maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 1);
    if (toDate > new Date(maxAllowedDate)) {
      NotificationExtension.Fails("Chỉ được phép lọc dữ liệu trong 1 tháng !");
      return;
    } else {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);

      let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
        pagination.pageSize
      }`;
      const search = form.getValues();
      if (search.maViTriList && search.maViTriList.length > 0) {
        search.maViTriList.forEach((maViTriList) => {
          url += `&MaViTriList=${maViTriList}`;
        });
      }
      if (search.StartTime) {
        url += `&startDate=${formatDateNotTimeZone(search.StartTime)}`;
      }
      if (search.EndTime) {
        url += `&endDate=${formatDateNotTimeZone(search.EndTime)}`;
      }
      if (search.itemCode && search.itemCode.length > 0) {
        search.itemCode.forEach((itemCode) => {
          url += `&MaVatTu=${itemCode}`;
        });
      }
      if (search.maKhoList && search.maKhoList.length > 0) {
        search.maKhoList.forEach((maKho) => {
          url += `&MaKho=${maKho}`;
        });
      }
      if (search.keySearch) {
        url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      if (search.LoaiGdNhapXuat) {
        url += `&LoaiGdNhapXuat=${search.LoaiGdNhapXuat}`;
      }
      if (search.LoaiChungTuList) {
        url += `&LoaiChungTuList=${search.LoaiChungTuList}`;
      }
      if (search.MaChiNhanhs && search.MaChiNhanhs.length > 0) {
        search.MaChiNhanhs.forEach((maChiNhanh) => {
          url += `&MaChiNhanhs=${maChiNhanh}`;
        });
      }
      try {
        const response = await repositoryDelivery.get(
          `api/v1/TblItemTransaction/get-list${url}`
        );
        if (response && response.success) {
          let result = response.data;
          setData(result);
          setRowCount(response.totalCount);
          table.resetRowSelection();
        }
      } catch (error) {
        setData([]);
        setIsError(true);
        console.error(error);
        return;
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
      }
    }
  };

  const fetchDataTotalItemTransaction = async () => {
    const fromDate = new Date(form.getValues()?.StartTime ?? "");
    const toDate = new Date(form.getValues()?.EndTime ?? "");

    let maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 1);
    if (toDate > new Date(maxAllowedDate)) {
      return;
    } else {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);

      let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
        pagination.pageSize
      }`;
      const search = form.getValues();
      if (search.maViTriList && search.maViTriList.length > 0) {
        search.maViTriList.forEach((maViTriList) => {
          url += `&MaViTriList=${maViTriList}`;
        });
      }
      if (search.StartTime) {
        url += `&startDate=${formatDateNotTimeZone(search.StartTime)}`;
      }
      if (search.EndTime) {
        url += `&endDate=${formatDateNotTimeZone(search.EndTime)}`;
      }
      if (search.itemCode && search.itemCode.length > 0) {
        search.itemCode.forEach((itemCode) => {
          url += `&MaVatTu=${itemCode}`;
        });
      }
      if (search.maKhoList && search.maKhoList.length > 0) {
        search.maKhoList.forEach((maKho) => {
          url += `&MaKho=${maKho}`;
        });
      }
      if (search.keySearch) {
        url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      if (search.LoaiGdNhapXuat) {
        url += `&LoaiGdNhapXuat=${search.LoaiGdNhapXuat}`;
      }
      if (search.LoaiChungTuList) {
        url += `&LoaiChungTuList=${search.LoaiChungTuList}`;
      }
      if (search.MaChiNhanhs && search.MaChiNhanhs.length > 0) {
        search.MaChiNhanhs.forEach((maChiNhanh) => {
          url += `&MaChiNhanhs=${maChiNhanh}`;
        });
      }
      try {
        const response = await repositoryDelivery.get(
          `api/v1/TblItemTransaction/total-item-transaction${url}`
        );
        if (response && response.success) {
          setDataTotalItem(response.data);
        }
      } catch (error) {
        setData([]);
        setIsError(true);
        console.error(error);
        return;
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
      }
    }
  };

  const exportDataExcel = async () => {
    const fromDate = new Date(form.getValues()?.StartTime ?? "");
    const toDate = new Date(form.getValues()?.EndTime ?? "");

    let maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 1);
    if (toDate > new Date(maxAllowedDate)) {
      NotificationExtension.Fails("Chỉ được phép lọc dữ liệu trong 1 tháng !");
      return;
    } else {
      // const baseUrl = `https://apis-pos-dev.hacom.vn/api-mdm/api/v1/ExportExcel/export-bao-cao-bang-ke-phieu-nhap-phieu-xuat`;
      // const fileName = "bang_ke_phieu_nhap_phieu_xuat.xlsx";
      // await exportDataToExcel(baseUrl, fileName);
      // const url = `/api/v1/ExportExcel/export-bao-cao-bang-ke-phieu-nhap-phieu-xuat`;
      open();
      try {
        let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
          pagination.pageSize
        }`;
        const search = form.getValues();
        if (search.maViTriList && search.maViTriList.length > 0) {
          search.maViTriList.forEach((maViTriList) => {
            url += `&MaViTriList=${maViTriList}`;
          });
        }
        if (search.StartTime) {
          url += `&startDate=${formatDateNotTimeZone(search.StartTime)}`;
        }
        if (search.EndTime) {
          url += `&endDate=${formatDateNotTimeZone(search.EndTime)}`;
        }
        if (search.itemCode && search.itemCode.length > 0) {
          search.itemCode.forEach((itemCode) => {
            url += `&MaVatTu=${itemCode}`;
          });
        }
        if (search.maKhoList && search.maKhoList.length > 0) {
          search.maKhoList.forEach((maKho) => {
            url += `&MaKhos=${maKho}`;
          });
        }
        if (search.keySearch) {
          url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
        }
        if (search.LoaiGdNhapXuat) {
          url += `&LoaiGdNhapXuat=${search.LoaiGdNhapXuat}`;
        }
        if (search.MaChiNhanhs && search.MaChiNhanhs.length > 0) {
          search.MaChiNhanhs.forEach((maChiNhanh) => {
            url += `&MaChiNhanhs=${maChiNhanh}`;
          });
        }
        const baseUrl = `/api/v1/ExportExcel/export-bao-cao-bang-ke-phieu-nhap-phieu-xuat${url}`;
        const _url = BASE_API_MDM + baseUrl;
        const token = localStorage.getItem("token");

        const response = await fetch(_url, {
          method: "GET",
          headers: {
            "Content-Type": "application/vnd.ms-excel",
            Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
          },
        });

        if (!response.ok) {
          NotificationExtension.Fails("Export Excel thất bại !");
        } else {
          const blob = await response.blob();
          const urlss = window.URL.createObjectURL(blob);
          const _name = new Date().toISOString().slice(0, 10);
          let filename = "bang_ke_phieu_nhap_phieu_xuat.xlsx";
          const link = document.createElement("a");
          link.href = urlss;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Export Excel thành công !");
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        close();
      }
    }
  };

  const DataItemCode = async (keySearch: string) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&ItemCodes=${keySearch}`;
      }
      // const response = await repositoryDelivery.get(
      //   `api/v1/TblInventorySerialOnhand/get-list-item-by-inv?Skip=0&Take=50` +
      //     url
      // );
      const response = await repositoryPos.get(
        `api/v1/tblitem/get-select?key=${keySearch}&page=25` + url
      );
      if (response && response.success) {
        const transformedData = response.data.map((branch: any) => ({
          // value: branch.maSp,
          // label: branch.maSp + " - " + branch.tenSp,
          value: branch.value,
          label: branch.text,
        }));
        // const uniqueData = Array.from(
        //   new Set(transformedData.map((item: any) => item.value))
        // ).map((value) =>
        //   transformedData.find((item: any) => item.value === value)
        // );
        setDataItemCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  // call api lấy loại giao dịch
  const dataInventoryTransactionType = async () => {
    try {
      const getData = await getTblInventoryTransactionType3();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblInventoryTransactionType(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const fetchDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.value && item.text && item.att1)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: item.att1?.toString(),
          id: item.value?.toString(),
        }));
      setDataBranch(data);
      form.setValues((prev) => ({
        ...prev,
        MaChiNhanhs:
          getValueById(String(userLoginHeader?.branchId), data, "value") &&
          String(getValueById(String(userLoginHeader?.branchId), data, "value"))
            .length > 0
            ? [
                String(
                  getValueById(String(userLoginHeader?.branchId), data, "value")
                ),
              ]
            : [],
      }));
    }
  };

  const fetchDataInv = async () => {
    const dataBranchSearch = selectIdBranch
      .map((item) => `&BranchId=${item}`)
      .join("");

    let url = "";

    if (selectIdBranch.length > 0) {
      url =
        `/api/v1/TblDmInventory/get-list-by-branchs?Skip=0&Take=${
          Number(selectIdBranch.length) * 20
        }` + dataBranchSearch;
    } else {
      url = `/api/v1/TblDmInventory/get-all`;
    }

    const res = await repositoryDelivery.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const result = res.data;
      if (selectIdBranch.length > 0) {
        const data = result
          ?.filter((item: any) => item.code && item.name)
          ?.map((item: any) => ({
            label: `${item.code} - ${item.name}`,
            value: item.code?.toString(),
            id: item.id?.toString(),
          }));
        setDataInv(data);
      } else {
        const data = result
          ?.filter((item: any) => item.name && item.code)
          ?.map((item: any) => ({
            label: `${item.code} - ${item.name}`,
            value: item.code?.toString(),
            id: item.id?.toString(),
          }));
        setDataInv(data);
      }
    }
  };

  const fetchDataItemPosition = async () => {
    const dataInvSearch = selectIdInv
      .map((item) => `subInvIds=${item}&`)
      .join("");

    let url = "";

    if (selectIdInv.length > 0) {
      url =
        `/api/v1/TblDmItemPosition/get-select-by-subInvIds?` + dataInvSearch;
    } else {
      url = `/api/v1/TblDmItemPosition/get-all`;
    }

    const res = await repositoryDelivery.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const result = res.data;
      if (selectIdInv.length > 0) {
        const data = result
          ?.filter((item: any) => item.positionCode && item.positionName)
          ?.map((item: any) => ({
            label: `${item.positionCode} - ${item.positionName}`,
            value: item.positionCode?.toString(),
          }));
        setDataPositionInv(data);
      } else {
        const data = result
          ?.filter(
            (item: any) => item.positionCode && item.positionName && item.active
          )
          ?.map((item: any) => ({
            label: `${item.positionCode} - ${item.positionName}`,
            value: item.positionCode?.toString(),
          }));
        setDataPositionInv(data);
      }
    }
  };

  useEffect(() => {
    const values = form.getValues();
    if (values?.MaChiNhanhs && values.MaChiNhanhs.length > 0) {
      const dataId = dataBranch
        ?.filter((item) => values?.MaChiNhanhs?.includes(item.value))
        ?.map((item) => item.id);

      setSelectIdBranch(dataId);
    } else {
      setSelectIdBranch([]);
    }
  }, [form.getValues()?.MaChiNhanhs]);

  useEffect(() => {
    const values = form.getValues();
    if (values?.maKhoList && values.maKhoList.length > 0) {
      const dataId = dataInv
        ?.filter((item) => values?.maKhoList?.includes(item.value))
        ?.map((item) => item.id);

      setSelectIdInv(dataId);
    } else {
      setSelectIdInv([]);
    }
  }, [form.getValues()?.maKhoList]);

  useEffect(() => {
    fetchDataInv();
  }, [selectIdBranch]);

  useEffect(() => {
    fetchDataItemPosition();
  }, [selectIdInv]);

  useEffect(() => {
    const runAsyncFunctions = async () => {
      await Promise.all([fetchDataBranch(), dataInventoryTransactionType()]);
    };
    const nextuse = async () => {
      await runAsyncFunctions();
      await fetchDataTotalItemTransaction();
      await fetchData();
    };
    nextuse();
  }, []);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableColumnFilters: false,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,
    rowCount,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "transactionNumber", "chungTuGoc"],
        right: ["statusName"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    getRowId: (row) => row.departmentId,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={visible} />

      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Group justify="space-between" gap={0}>
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => exportDataExcel()}
          >
            Export Excel
          </Button>
        </Group>
        <Grid mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              key={form.key("keySearch")}
              placeholder="Nhập từ khóa"
              type="text"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              // onChange={(e) => {
              //   handleChangeSearchValue(e.target.value ?? "", "keySearch");
              // }}
              {...form.getInputProps("keySearch")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                  fetchDataTotalItemTransaction();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              key={form.key("LoaiGdNhapXuat")}
              placeholder="Trạng thái"
              searchable
              clearable
              data={[
                { value: "1", label: "Nhập" },
                { value: "2", label: "Xuất" },
              ]}
              leftSection={<IconSwitch size={20} color="#15aabf" />}
              // onChange={(value) =>
              //   handleChangeSearchValue(value ?? "", "LoaiGdNhapXuat")
              // }
              {...form.getInputProps("LoaiGdNhapXuat")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Chi nhánh"
              data={dataBranch?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              value={
                form.getValues()?.MaChiNhanhs
                  ? form.getValues()?.MaChiNhanhs
                  : []
              }
              searchable
              clearable
              leftSection={<IconBrandBootstrap size={20} color="#15aabf" />}
              onChange={(e) => {
                form.setValues((prev) => ({
                  ...prev,
                  MaChiNhanhs: e ? e : [],
                }));
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Mã kho"
              searchable
              clearable
              data={dataInv?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              value={
                form.getValues()?.maKhoList ? form.getValues()?.maKhoList : []
              }
              onChange={(e) => {
                form.setValues((prev) => ({ ...prev, maKhoList: e ? e : [] }));
              }}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Mã vị trí"
              searchable
              clearable
              leftSection={<IconBuildingFactory size={20} color="#15aabf" />}
              data={dataPositionInv}
              onChange={(e) =>
                form.setValues((prev) => ({ ...prev, maViTriList: e ? e : [] }))
              }
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Mã sản phẩm"
              key={form.key("itemCode")}
              clearable
              searchable
              data={dataItemCode.map((x) => x.value)}
              //    value={search.itemCode}
              renderOption={renderMultiSelectOption}
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              onSearchChange={(value) => {
                if (value.length >= 3) {
                  DataItemCode(value);
                }
              }}
              // onChange={(value) => {
              //   // handleChangeValue(value, "itemCode");
              //   form.setFieldValue("itemCode", value);
              // }}
              {...form.getInputProps("itemCode")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              searchable
              clearable
              leftSection={<IconFileTypography color="#15aabf" />}
              size="sm"
              placeholder="Chọn loại giao dịch"
              data={dataTblInventoryTransactionType}
              // onChange={(value) => {
              //   console.log("value", value);
              // }}
              key={form.key("LoaiChungTuList")}
              {...form.getInputProps("LoaiChungTuList")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("StartTime")}
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              // onChange={(e) => {
              //   handleChangeSearchValue(formatDateNotTimeZone(e), "StartTime");
              // }}
              {...form.getInputProps("StartTime")}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              key={form.key("EndTime")}
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              // onChange={(e) => {
              //   handleChangeSearchValue(formatDateNotTimeZone(e), "EndTime");
              // }}
              {...form.getInputProps("EndTime")}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              color="blue"
              variant="outline"
              onClick={() => {
                fetchData();
                fetchDataTotalItemTransaction();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default InventoryTransactionsReport;
type Department = {
  loaiGdNhapXuat: number;
  maGd: string;
  ngayGd: string;
  loaiGd: string;
  chungTuGoc: string;
  dienGiai: string;
  idChiNhanh: number;
  maCn: string;
  tenCn: string;
  idKho: string;
  maKho: string;
  locatorId: number | null;
  maViTri: string | null;
  transactionId: number;
  itemId: number;
  itemCode: string;
  itemName: string;
  serialNumber: string;
  serialStatus: string;
  dvt: string | null;
  soLuong: number;
  soLuongNhap: number;
  soLuongXuat: number;
  donGia: number;
  maNv: string;
  tenNv: string;
  phongBanGd: string;
  idCnGd: number;
  tenCnGd: string;
  maNhomSp: string;
};
